import * as actionTypes from '../constants/actionTypes';
import * as api from '../api';
import { toast } from "react-toastify";

export const getObjectiveList = () => async dispatch =>{
    try {
        dispatch({ type: actionTypes.GET_OBJECTIVE_REQUEST })
        const { data } = await api.getObjectiveList();
        dispatch({ type: actionTypes.GET_OBJECTIVE_SUCCESS, payload: data })
        // toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.GET_OBJECTIVE_FAIL, payload: err.response.data.message })
    }
}

export const createObjective = (value) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.CREATE_OBJECTIVE_REQUEST })
        const { data } = await api.createObjective(value);
        dispatch({ type: actionTypes.CREATE_OBJECTIVE_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CREATE_OBJECTIVE_FAIL, payload: err.response.data.message })
    }
}

export const updateObjective = (formData) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_REQUEST })
        const { data } = await api.updateObjective(formData)
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_SUCCESS, payload: data })
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_RESET })
        toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_CLIENT_FAIL, payload: err.response.data.message })
    }
}

export const deleteObjective = (objectiveId) => async dispatch =>{ 
    try {
        dispatch({ type: actionTypes.DELETE_OBJECTIVE_REQUEST })
        const { data } = await api.deleteObjective(objectiveId)
        dispatch({ type: actionTypes.DELETE_OBJECTIVE_SUCCESS, payload: objectiveId })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.DELETE_OBJECTIVE_FAIL, payload: err.response.data.message })
    }

}

export const getHomePageContent = ()=> async dispatch => {
    try {
        dispatch({ type: actionTypes.GET_HOME_PAGE_REQUEST })
        const { data } = await api.getHompageContent();
        dispatch({ type: actionTypes.GET_HOME_PAGE_SUCCESS, payload: data })
        // toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.GET_HOME_PAGE_FAIL, payload: err.response.data.message })
    }
}

export const createPageContent = (content) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.CREATE_HOME_PAGE_REQUEST })
        const { data } = await api.createPageContent(content);
        toast.success(data.message);
        dispatch({ type: actionTypes.CREATE_HOME_PAGE_SUCCESS, payload: data })
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CREATE_HOME_PAGE_FAIL, payload: err.response.data.message })
    }
}
/**
* function for user update changeObjectiveStatus
* @param {*} data User data 
* @description update user infromation
* @param {function} changeObjectiveStatus changeObjectiveStatus function
*/
export const changeObjectiveStatus = userData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_REQUEST })
        const { data } = await api.updateObjectiveStatus(userData)
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_SUCCESS, payload: data })
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_RESET })
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_OBJECTIVE_FAIL, payload: err.response.data.message })
    }
}
/**
* function for user update getAudienceList
* @param {*} data User data 
* @description update user infromation
* @param {function} getAudienceList getAudienceList function
*/
export const getAudienceList = () => async dispatch =>{
    try {
        dispatch({ type: actionTypes.GET_AUDIENCE_REQUEST })
        const { data } = await api.getAudienceList();
        dispatch({ type: actionTypes.GET_AUDIENCE_SUCCESS, payload: data })
        // toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.GET_AUDIENCE_FAIL, payload: err.response.data.message })
    }
}

export const createAudience = (value) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.CREATE_AUDIENCE_REQUEST })
        const { data } = await api.createAudience(value);
        dispatch({ type: actionTypes.CREATE_AUDIENCE_SUCCESS, payload: data })
        toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.CREATE_AUDIENCE_FAIL, payload: err.response.data.message })
    }
}

export const updateAudience = (formData) => async dispatch =>{
    try {
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_REQUEST })
        const { data } = await api.updateAudience(formData)
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_SUCCESS, payload: data })
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_RESET })
        toast.success(data.message);
    } catch (err) {
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_CLIENT_FAIL, payload: err.response.data.message })
    }
}

export const deleteAudience = (objectiveId) => async dispatch =>{ 
    try {
        dispatch({ type: actionTypes.DELETE_AUDIENCE_REQUEST })
        const { data } = await api.deleteAudience(objectiveId)
        dispatch({ type: actionTypes.DELETE_AUDIENCE_SUCCESS, payload: objectiveId })
        toast.success(data.message);
    } catch (err) {
        console.log(err)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.DELETE_AUDIENCE_FAIL, payload: err.response.data.message })
    }
}

/**
* function for user update changeObjectiveStatus
* @param {*} data User data 
* @description update user infromation
* @param {function} changeObjectiveStatus changeObjectiveStatus function
*/
export const changeAudienceStatus = userData => async (dispatch, getState) => {
    try {
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_REQUEST })
        const { data } = await api.updateAudienceStatus(userData)
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_SUCCESS, payload: data })
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_RESET })
        toast.success(data.message);
    } catch (err) {
        console.log(err.response.data.message)
        toast.error(err.response.data.message);
        dispatch({ type: actionTypes.UPDATE_AUDIENCE_FAIL, payload: err.response.data.message })
    }
}
